(function () {
  'use strict';

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = String(count);
    });
  }

  // Fetch cart count on load
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCartCount(cart.item_count); })
    .catch(function () {});

  // Product gallery thumbs
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-full-src');
        var alt = btn.getAttribute('data-alt') || '';
        if (main && src) {
          main.src = src;
          main.alt = alt;
        }
        thumbs.forEach(function (t) {
          t.setAttribute('aria-pressed', 'false');
          var img = t.querySelector('img');
          if (img) img.classList.remove('is-active');
        });
        btn.setAttribute('aria-pressed', 'true');
        var activeImg = btn.querySelector('img');
        if (activeImg) activeImg.classList.add('is-active');
      });
    });
  });

  // Collection sort
  var sortSelect = document.querySelector('[data-collection-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
})();
